import { HttpResult } from "widgets-for-react"

export const getNavigationItems = async (): Promise<HttpResult<string[]>> => {
  const res = await fetch("/api/v1/departments/navigation")

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: string[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data,
  }
}
